export type SortDirection = "asc" | "desc";

/**
 * Comparator shared by every Fetcher Settings table. Ids and counts come back
 * as numeric strings, so anything that parses as a number sorts numerically and
 * everything else sorts as text.
 */
export function sortRows<T extends { [key: string]: any }>(
  rows: T[],
  sortKey: string | null,
  direction: SortDirection,
): T[] {
  if (!sortKey) return rows;
  const sign = direction === "asc" ? 1 : -1;
  return [...rows].sort((a, b) => {
    const left = a[sortKey];
    const right = b[sortKey];
    if (left == null) return 1;
    if (right == null) return -1;
    const leftNumber = Number(left);
    const rightNumber = Number(right);
    const numeric =
      left !== "" &&
      right !== "" &&
      !Number.isNaN(leftNumber) &&
      !Number.isNaN(rightNumber);
    const comparison = numeric
      ? leftNumber - rightNumber
      : String(left).localeCompare(String(right));
    return comparison * sign;
  });
}
